module.exports = __webpack_public_path__ + "img/education.4a3db741.jpg";